<template>
  <v-container>
    <!-- layout toggle -->
    <v-row>
      <v-col class="text-left">
        <v-btn-toggle v-model="layout" dense mandatory>
          <v-btn v-for="item in layouts" :key="item.code" :value="item.value">
            {{ item.text }}
            <v-icon right>{{ item.icon }}</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-fade-transition leave-absolute>
        <v-col v-if="layout === 'TABLE'" key="TABLE" cols="12">
          <audit-view-table :audits="audits">
            <!-- passthrough slots -->
            <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
            <template
              v-for="(_, name) in $scopedSlots"
              :slot="name"
              slot-scope="slotData"
            >
              <slot :name="name" v-bind="slotData" />
            </template>
          </audit-view-table>
        </v-col>
        <v-col
          v-else-if="layout === 'EXPANSION_PANEL'"
          key="TIMELINE"
          cols="12"
        >
          <audit-view-expansion-panel :audits="audits">
            <!-- passthrough slots -->
            <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
            <template
              v-for="(_, name) in $scopedSlots"
              :slot="name"
              slot-scope="slotData"
            >
              <slot :name="name" v-bind="slotData" />
            </template>
          </audit-view-expansion-panel>
        </v-col>
        <v-col v-else key="OTHER" cols="12">
          {{ $t('fresh-vue-audits.AuditView.no-layout') }}
        </v-col>
      </v-fade-transition>
    </v-row>
  </v-container>
</template>

<script>
import AuditViewTable from './AuditViewTable'
import AuditViewExpansionPanel from './AuditViewExpansionPanel'

export default {
  name: 'AuditView',

  components: {
    AuditViewTable,
    AuditViewExpansionPanel
  },

  props: {
    audits: {
      type: Array,
      required: false,
      default: null
    },

    defaultLayout: {
      type: String,
      required: false,
      default: 'TABLE',
      validator: (value) => ['TABLE', 'EXPANSION_PANEL'].includes(value)
    }
  },

  data() {
    return {
      layouts: [
        { text: 'Tabelle', value: 'TABLE', icon: '$freshvueaudits-view-table' },
        {
          text: 'Liste',
          value: 'EXPANSION_PANEL',
          icon: '$freshvueaudits-view-expansion-panel'
        }
      ],

      layout: 'TABLE'
    }
  },

  watch: {
    defaultLayout: {
      handler: function (value) {
        this.layout = value
      },
      immediate: true
    }
  }
}
</script>
